/*
 * @Author: 大明冯
 * @Date: 2018-08-07 10:37:35
 * @Last Modified by: 大明冯
 * @Last Modified time: 2018-08-07 11:50:16
 */

import { WRITE_STATE, CLEAN_STATE, STATE} from './../mutations-types'

const state = {
  [STATE]: JSON.parse(window.sessionStorage.getItem(STATE) || '[]')
}


const mutations = {
  [WRITE_STATE]: (state, index) => {
    state[STATE] = index
  },

  [CLEAN_STATE]: (state) => {
    state[STATE] = []
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/nav_state.js